'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable no-undef */


var _utils = require('./utils');

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var root = {};

var history = void 0;

if (typeof window !== 'undefined') {
  var createHistory = require('history');
  history = createHistory.createBrowserHistory();

  root = window;
} else {
  var _createHistory = require('history');
  history = _createHistory.createMemoryHistory();
}

// 注册bridge
root.RegBridge = {};

// 打印日志
var print = function print(msg) {
  var _console;

  for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  // eslint-disable-next-line no-use-before-define
  JSBridge.debug && (_console = console).info.apply(_console, ['JSBridge => ' + msg + ' \n'].concat(params));
};

// 待执行的任务栈
var fnStack = [];
var timer = void 0;

// 等待加载
var ready = function ready(fn) {
  if (typeof root.iHealthBridge !== 'undefined') {
    fn();
    return;
  }
  fnStack.push(fn);

  if (timer) return;
  timer = setInterval(function () {
    if (typeof root.iHealthBridge !== 'undefined') {
      clearInterval(timer);

      var refn = void 0;
      // eslint-disable-next-line no-cond-assign
      while (refn = fnStack.shift()) {
        refn();
      }
    }
  }, 200);
};

// 默认设置
var JSBridge = {
  // 是否开启debug模式
  debug: true,
  // 获取当前环境
  env: utils.env(),
  // 设置前端路由
  router: history,
  /**
   * 准备好了调用原生功能
   * @param  fn     [Function]   额外传递的参数
   */
  ready: function ready(fn) {
    print('ready(fn)', fn);
    fn();
  },
  // 目前支持的dataTypeList，locationInfo暂时没有授权
  dataTypeList: ['userInfo', 'deviceInfo', 'networkInfo', 'locationInfo'],
  // 获取App当前版本号
  app_version: function app_version() {
    print('app_version()', '5.3.0');
    return '5.3.0';
  },
  /**
   * 登录状态
   * @return {number} [1 登录 0 未登录]
   */
  isLogin: function isLogin() {
    var ua = document.cookie.match(new RegExp('iybLoginCookieKey=([^;]*)')) || [];
    return ua[0] && ua[1] && ua[1] !== 'iyb_guest_access_key' ? 1 : 0;
  },
  /**
   * 获取指定数据类型的数据  具体查看dataTypeList
   * @param  dataType   [String]   获取的数据类型，可选[userInfo, deviceInfo, networkInfo]
   * @param  extra      [String]   额外传递的参数
   * @param  callBack   [Function] 回调方法
   */
  getData: function getData(dataType, extra, callBack) {
    print('getData(dataType, extra, callback)', dataType, extra, callBack);
  },
  /**
   * 跳转到指定页面
   * @param  url  [string]   获取的数据类型
   */
  go: function go(url) {
    print('go(' + url + ')', url);
    if (JSBridge.router && !utils.isURL(url)) {
      try {
        JSBridge.router.push(url);
      } catch (err) {
        root.location.href = url;
      }
    } else {
      root.location.href = url;
    }
  },
  // 返回上一页
  goBack: function goBack() {
    print('goHistory()');
    if (JSBridge.router) {
      JSBridge.router.go(-1);
    } else {
      root.history.go(-1);
    }
  },
  /**
   * 跳转到登录页
   * @param  backUrl    [String]   登录完成，跳转地址
   * @param  extra      [Object]   传入的额外参数
   * @config clearCache [Boolean]  清除缓存
   * @param  callback   [Function] 回调方法
   */
  goLogin: function goLogin(backUrl, extra, callback) {
    print('goLogin(backUrl, extra, callback)', backUrl, extra, callback);
  },
  /**
   * 跳转小程序
   * @param  obj            [Object]  参数
   * @config appID          [String]  小程序ID
   * @config path           [String]  小程序转发路径(当前页面 path ，必须是以 / 开头的完整路径)
   * @param  callback [Function] 回调
   * @version >= 5.0.0
   */
  goApplets: function goApplets(obj, callback) {
    print('goApplets(obj, callback)', obj, callback);
  },
  /**
   * 设置页面标题
   * @param  title  [String]  设置标题
   */
  setTitle: function setTitle(title) {
    print('setTitle(title)', title);

    document.title = title;
  },
  /**
   * 设置左上角按钮
   * @param  obj      [Object]   参数
   * @config title    [String]   按钮名称
   * @config color [String]   按钮颜色
   * @config fontSize [String]   按钮字体大小
   * @config imageUrl [String]   图片按钮url地址
   * @param  callback [function] 回调
   */
  setBackButton: function setBackButton(obj, callback) {
    print('setRightButton(params, callback)', obj, callback);
  },

  /**
   * 设置左上角按钮
   */
  setStepCount: function setStepCount() {
    print('setStepCount()');
  },

  /**
   * 设置右上角按钮
   * @param  obj      [Object]   参数
   * @config title    [String]   按钮名称
   * @config imageUrl [String]   图片按钮url地址
   * @config color    [String]   按钮颜色
   * @config fontSize [String]   按钮字体大小
   * @param  callback [function] 回调
   */
  setRightButton: function setRightButton(obj, callback) {
    print('setRightButton(obj, callback)', obj, callback);
  },

  /**
   * 设置右上角分享
   * @param  obj      [Object]   分享参数
   * @config title    [String]   分享标题
   * @config desc     [String]   分享摘要
   * @config imageUrl [String]   分享图片
   * @config link     [String]   分享链接
   * @param  share      [Object]   按钮参数
   * @config title    [String]   按钮名称
   * @config imageUrl [String]   图片按钮url地址
   * @param  callback [function] 回调
   */
  setRightShare: function setRightShare(share, obj, callback) {
    print('setRightShare(obj, share, callback)', obj, share, callback);
  },

  /**
   * 设置右上角菜单
   * @param   obj       [object]    参数
   * @config  wareId    [string]    wareID
   * @config  productId [string]    产品ID
   * @param   callback  [function]  回调
   */
  setRightMenu: function setRightMenu(obj, callback) {
    print('setRightMenu(obj, callback)', obj, callback);
  },

  /**
   * 隐藏右上角菜单
   * @param   callback  [function]  回调
   */
  hideRightMenu: function hideRightMenu(callback) {
    print('setRightMenu(callback)', callback);
  },

  /**
   * 调起分享
   * @param  obj      [Object]   分享参数
   * @config title    [String]   分享标题
   * @config desc     [String]   分享摘要
   * @config imageUrl [String]   分享图片
   * @config link     [String]   分享链接
   * @param  callback [function] 回调
   */
  share: function share(obj, callback) {
    print('share(obj, callback)', obj, callback);
  },
  /**
   * 调起原生分享文件
   * @param  obj      [Object]   分享参数
   * @config  url     [String]   分享链接
   * @param  callback [Funcgion] 回调
   */
  shareFile: function shareFile(obj, callback) {
    print('shareFile(obj, callback)', obj, callback);
  },
  /**
   * 二维码
   * @param  obj      [Object]   分享参数
   * @config url      [String]   二维码地址
   * @config direct   [Boolean]  扫码后是否立即返回
   * @param  callback [function] 回调
   */
  scanQRCode: function scanQRCode(obj, callback) {
    print('scanQRCode(obj, callback)', obj, callback);
  },
  /**
   * 保存图片至相册
   * @param  obj                  [Object]   参数配置
   * @config imgUrl               [String]   图片地址
   * @param  callback             [Funcgion] 回调
   */
  saveImage: function saveImage(obj, callback) {
    print('saveImage(obj, callback)', obj, callback);
  },
  /**
   * 图集展示
   * @param  obj      [Object]   图集参数
   * @config images   [Array]    图片参数
   * @config index    [Number]   展示当前图片
   * @param  callback [Funcgion] 回调
   */
  galleryView: function galleryView(obj, callback) {
    print('scanQRCode(obj, callback)', obj, callback);
  },
  /**
   * 人脸检测
   * @param  callback             [Funcgion] 回调
   * @config callbackParams       [Object]   参数
   * @config callbackParams.image [Object]   回调Base64图片
   */
  faceDetect: function faceDetect(callback) {
    print('faceDetect(callback)', callback);
  },
  /**
   * 腾讯人脸检测
   * @param  detectParams           [Object]   参数
   * @config detectParams.name      [String]   姓名
   * @config detectParams.certNo    [String]   身份证号
   * @param  callback               [Funcgion] 回调
   * @config callbackParams         [Object]   参数
   * @config callbackParams.image   [String]   回调Base64图片
   * @config callbackParams.orderNo [String]  用于查询人脸识别结果的订单号
   */
  faceDetectTencent: function faceDetectTencent(detectParams, callback) {
    print('faceDetectTencent(detectParams)', detectParams);
    print('faceDetectTencent(callback)', callback);
  },
  /**
   * 获取用户ID
   * @return  [string] 用户ID
   */
  accountId: function accountId() {
    print('accountId()');
    return '';
  },

  /**
   * 获取注册方法名
   * @param  {String}   method [方法名]
   * @example
   * IYBBridge.getRegMethod('iyunbao.bbs.comment')
   */
  getRegMethod: function getRegMethod(method) {
    if (root.RegBridge && root.RegBridge[method]) {
      return 'RegBridge.' + method + '()';
    }

    return '';
  },
  /**
   * 注册方法名
   * @param  {String}   method [方法名]
   * @param  {Function} cb     [回调]
   * @return {Number}          [1为成功，0为失败]
   * @example
   * JSBridge.register('iyunbao.bbs.comment')
   */
  register: function register(method, callback) {
    if (typeof method === 'string' && typeof callback === 'function') {
      root.RegBridge[method] = callback;
      return 1;
    }
    return 0;
  },
  /**
   * 注销方法名
   * @param  {String}   method [方法名]
   * @example
   * JSBridge.unregister('iyunbao.bbs.comment')
   */
  unregister: function unregister(method) {
    delete root.RegBridge[method];
  }
};

// 在微信客户端
if (utils.env() === 'wechat') {
  JSBridge.setTitle = function (title) {
    print('setTitle(title)', title);
    utils.setTitleWechat(title);
  };
}

// 在i云保App或者最福利App，外部短链跳转IOS未注入navigator.userAgent iyunbao
if (utils.env() === 'iyunbao' || utils.env() === 'ifuli' || typeof iHealthBridge !== 'undefined') {
  JSBridge.ready = function (fn) {
    print('ready(fn)', fn);
    ready(fn);
  };

  /**
   * 获取App当前版本号
   * return
   */
  JSBridge.app_version = function () {
    return typeof iHealthBridge !== 'undefined' && typeof iHealthBridge.app_version === 'function' ? iHealthBridge.app_version() : '5.3.0';
  };

  // JSBridge.getData = (dataType, extra, callBack) => {
  //   print('getData(dataType, extra, callback)', dataType, extra, callBack);
  //
  //   if (typeof extra === 'function') {
  //     callBack = extra;
  //     extra = null;
  //   }
  //
  //   typeof iHealthBridge !== 'undefined' && iHealthBridge.getData(dataType, extra, callBack);
  // };

  JSBridge.getData = function (dataType, extra, callBack) {
    print('getData(dataType, extra, callback)', dataType, extra, callBack);

    if (typeof extra === 'function') {
      callBack = extra;
      extra = null;
    } else {
      console.warn('JSBridge.getData extra 参数不在支持');
    }

    typeof iHealthBridge !== 'undefined' && iHealthBridge.getData(dataType, callBack);
  };

  JSBridge.go = function (url) {
    if (!utils.isURL(url)) {
      var basename = JSBridge.router && JSBridge.router.location && JSBridge.router.location.basename;
      if (basename) {
        url = root.location.origin + basename + url;
      } else {
        url = root.location.origin + url;
      }
    }
    print('go(url)', url);
    typeof iHealthBridge !== 'undefined' && iHealthBridge.goWebView(url);
  };

  JSBridge.goBack = function () {
    print('goBack()');
    typeof iHealthBridge !== 'undefined' && iHealthBridge.goBack();
  };

  JSBridge.goLogin = function (backUrl, extra, callback) {
    print('goLogin(backUrl, extra, callback)', backUrl, extra, callback);
    typeof iHealthBridge !== 'undefined' && iHealthBridge.goLogin(backUrl, extra, callback);
  };

  JSBridge.goApplets = function (obj, callback) {
    print('goApplets(obj, callback)', obj, callback);

    obj = _extends({
      path: '/'
    }, obj);

    typeof iHealthBridge !== 'undefined' && iHealthBridge.doAction('goApplets', JSON.stringify(obj), callback);
  };

  JSBridge.setTitle = function (title) {
    print('setTitle(title)', title);

    typeof iHealthBridge !== 'undefined' && iHealthBridge.doAction('setTitle', JSON.stringify({ title: title }));
  };

  JSBridge.setStepCount = function () {
    print('setStepCount()');

    // ui.bbb.pagename = iyb-h5 => https://h5.iyunbao.com/m/home/step/count

    typeof iHealthBridge !== 'undefined' && iHealthBridge.doAction('syncSteps');
  };

  JSBridge.setBackButton = function (obj, callback) {
    print('setBackButton(obj, callback)', obj, callback);
    obj.image = obj.imageUrl;
    typeof iHealthBridge !== 'undefined' && iHealthBridge.doAction('setBackButton', JSON.stringify(obj), callback);
  };

  JSBridge.setRightButton = function (obj, callback) {
    print('setRightButton(obj, callback)', obj, callback);
    obj.image = obj.imageUrl;

    typeof iHealthBridge !== 'undefined' && iHealthBridge.doAction('setRightButton', JSON.stringify(obj), callback);
  };

  JSBridge.setRightShare = function (share, obj, callback) {
    print('setRightShare(share, obj, callback)', share, obj, callback);

    // 替换换行
    if (share.title) {
      share.title = share.title.replace(/\r\n/g, '');
      share.title = share.title.replace(/\n/g, '');
    }

    // 替换换行
    if (share.desc) {
      share.desc = share.desc.replace(/\r\n/g, '');
      share.desc = share.desc.replace(/\n/g, '');
    }

    share.thumb = share.imageUrl;

    obj = _extends({
      action: "iHealthBridge.doAction('share', '" + JSON.stringify(share) + "')"
    }, obj);

    obj.title = '分享';
    // obj.image = obj.imageUrl;

    typeof iHealthBridge !== 'undefined' && iHealthBridge.doAction('setRightButton', JSON.stringify(obj), callback);
  };

  JSBridge.setRightMenu = function (obj, callback) {
    typeof iHealthBridge !== 'undefined' && iHealthBridge.doAction('setRightMenu', JSON.stringify(obj), callback);
  };

  JSBridge.hideRightMenu = function (callback) {
    typeof iHealthBridge !== 'undefined' && iHealthBridge.doAction('hideRightMenu', callback);
  };

  JSBridge.share = function (obj, callback) {
    print('share(obj, callback)', obj, callback);
    // obj.platform = utils.getSharePlatform({
    //   wechat: '22',
    //   'wechat-timeline': '23',
    //   qq: '24',
    //   qqzone: '6',
    // }, obj.platform);
    obj.thumb = obj.imageUrl;
    typeof iHealthBridge !== 'undefined' && iHealthBridge.doAction('share', JSON.stringify(obj), callback);
  };

  JSBridge.shareFile = function (obj, callback) {
    print('shareFile(obj, callback)', obj, callback);

    typeof iHealthBridge !== 'undefined' && iHealthBridge.doAction('shareFile', obj, callback);
  };

  JSBridge.scanQRCode = function (obj, callback) {
    print('scanQRCode(obj, callback)', obj, callback);
    obj.unpush = obj.direct;
    typeof iHealthBridge !== 'undefined' && iHealthBridge.doAction('scanQRCode', JSON.stringify(obj), callback);
  };

  JSBridge.saveImage = function (obj, callback) {
    print('saveImage(obj, callback)', obj, callback);
    typeof iHealthBridge !== 'undefined' && iHealthBridge.doAction('saveImage', JSON.stringify(obj), callback);
  };

  JSBridge.galleryView = function (obj, callback) {
    print('galleryView(obj, callback)', obj, callback);
    typeof iHealthBridge !== 'undefined' && iHealthBridge.doAction('galleryView', JSON.stringify(obj), callback);
  };

  JSBridge.faceDetect = function (callback) {
    print('faceDetect(callback)', callback);
    typeof iHealthBridge !== 'undefined' && iHealthBridge.doAction('faceDetect', '', callback);
  };

  JSBridge.faceDetectTencent = function (detectParams, callback) {
    print('faceDetectTencent(detectParams)', detectParams);
    print('faceDetectTencent(callback)', callback);
    typeof iHealthBridge !== 'undefined' && iHealthBridge.doAction('faceDetectTencent', JSON.stringify(detectParams), callback);
  };

  JSBridge.accountId = function () {
    print('accountId()');
    return typeof iHealthBridge !== 'undefined' && typeof iHealthBridge.accountId === 'function' ? iHealthBridge.accountId() : '';
  };
}

exports.default = JSBridge;